import { useState, useEffect } from 'react'
import { apiUrl } from '../../config/api'
import './PlatformStats.css'

export default function PlatformStats() {
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch(apiUrl('stats'))

        if (response.ok) {
          const data = await response.json()
          setStats(data)
        }
      } catch (error) {
        console.error('Failed to fetch platform stats:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchStats()
  }, [])

  if (loading) {
    return (
      <section className="platform-stats-section">
        <h3 className="stats-title">RiftChess Stats</h3>
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-value">—</div>
            <div className="stat-label">Players</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">—</div>
            <div className="stat-label">Games Played</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">—</div>
            <div className="stat-label">Active Games</div>
          </div>
          <div className="stat-card monthly-prizes">
            <div className="stat-value">$2700+</div>
            <div className="stat-label">Monthly Prizes</div>
          </div>
        </div>
      </section>
    )
  }

  if (!stats) {
    return null
  }

  return (
    <section className="platform-stats-section">
      <h3 className="stats-title">RiftChess Stats</h3>
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">{stats.total_players?.toLocaleString() || '0'}</div>
          <div className="stat-label">Players</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{stats.total_games?.toLocaleString() || '0'}</div>
          <div className="stat-label">Games Played</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{stats.active_games?.toLocaleString() || '0'}</div>
          <div className="stat-label">Active Games</div>
        </div>
        <div className="stat-card monthly-prizes">
          <div className="stat-value">$2700+</div>
          <div className="stat-label">Monthly Prizes</div>
        </div>
      </div>
    </section>
  )
}